import React from 'react';
import { useLottie } from 'lottie-react';
import receivedServiceAnimation from '../../../lotties/evaluationAnimation.json';
import i18n from '../../../utils/i18n';
import './Animation.scss';

const EvaluationAnimation = (): JSX.Element => {
	const defaultOptions = {
		loop: true,
		autoplay: true,
		animationData: receivedServiceAnimation,
	};

	const { View } = useLottie(defaultOptions);

	return (
		<div className="tracking-animation">
			<div className="lottie-container evaluation-animation">
				<div>{View}</div>
			</div>
			<div className="text-animation">
				<p>
					{i18n.get(
						'tracking.animations.evaluation.title',
						'Al finalizar la asistencia, no olvides evaluar nuestro servicio.'
					)}
				</p>
			</div>
		</div>
	);
};

export default EvaluationAnimation;
